import { AppointmentStatus } from "../types/appointment.types";

const APPOINTMENT_STATUS_COLOR_MAPPER: Record<
  AppointmentStatus,
  { color: string; bgColor: string }
> = {
  Confirmed: {
    color: "#00B917",
    bgColor: "#E8F5E9",
  },
  Scheduled: {
    color: "#417DE0",
    bgColor: "#DCE6F7",
  },
  Canceled: {
    color: "#FF3939",
    bgColor: "#FFE1E0",
  },
  Completed: {
    color: "#00B917",
    bgColor: "#E8F5E9",
  },
  "Checked In": {
    color: "#7048C2",
    bgColor: "#F3EEFF",
  },
};


export const getStatusConfig = (status: AppointmentStatus) => {
  return APPOINTMENT_STATUS_COLOR_MAPPER[status];
};


